import * as type from './type';
import {CHOOSE_COUPON} from "./type";


export const getPoint = (payload) => {

  return {
    type: type.GET_POINT,
    payload,
  };
};

export const getPointSuccess = (payload) => {

  return {
    type: type.GET_POINT_SUCCESS,
    payload,
  };
};

export const getCoupon = (payload) => {

  return {
    type: type.GET_COUPON,
    payload,
  };
};

export const getCouponSuccess = (payload) => {

  return {
    type: type.GET_COUPON_SUCCESS,
    payload,
  };
};

export const chooseCoupon = (payload) => {
  return {
    type: type.USE_COUPON,
    payload,
  };
}

export const resetChooseCoupon = () => {
  return {
    type: type.RESET_COUPON,
  };
}

export const exchangePointToCouponRequest = (payload) => {
  console.log(payload, 'payload');
  return {
    type: type.EXCHANGE_POINT_TO_COUPON_REQUEST,
    payload,
  };
};

export const exchangePointToCouponSuccess = (payload) => {
  return {
    type: type.EXCHANGE_POINT_TO_COUPON_SUCCESS,
    payload,
  };
}

export const exchangePointToCouponFailed = (payload) => {
  return {
    type: type.EXCHANGE_POINT_TO_COUPON_FAILED,
    payload
  };
}